import React, {Suspense} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ReportAnalytics } from '../components/Reports/blocks/ReportAnalytics';
import { Route } from '@/models';

export const RouteWrapper: React.FC<Route & {component: React.LazyExoticComponent<React.ComponentType<any>>}> = ({
  path,
  title,
  component: Component,
  ...rest
}) => {
  const location = useLocation();
  const loggedPath = location?.pathname || path;
  const props = {
    path,
    title,
    location,
    params: useParams(),
    ...rest,
  };

  return (
    <ReportAnalytics path={loggedPath} title={title}>
      <Suspense fallback={<div>Loading...</div>}>
        <Component {...props} />
      </Suspense>
    </ReportAnalytics>
  );
}

export default RouteWrapper;